import Modal from "../../../../../global/Modal";
import useSettlementPaymentsModal from "../../../hooks/useSettlementPaymentsModal";

import SettlementPaymentsForm from "./SettlementPaymentsForm";

export default function SettlementPaymentsModal(props) {
  const { mode = "edit", openModal, paymentData } = props;
  const { formValues, isDirty, isSaving, isSaveDisabled, handleFieldOnChange, handleCancel, handleSave } =
    useSettlementPaymentsModal(props);

  if (mode === "edit" && !paymentData) {
    return null;
  }

  return (
    <Modal open={openModal} onClose={props.handleCloseModal} maxWidth="md">
      <div>
        <SettlementPaymentsForm
          title={mode === "add" ? "Add Payment" : "Edit Payment"}
          caseDetail={props.caseDetail}
          casePk={props.caseId}
          values={formValues}
          paymentTypeOptions={props.paymentTypeOptions}
          loading={isSaving}
          cancelDisabled={!isDirty}
          saveDisabled={!isDirty || isSaveDisabled}
          onChange={handleFieldOnChange}
          onCancel={handleCancel}
          onSave={handleSave}
        />
      </div>
    </Modal>
  );
}
